import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';

function TabPanel({ children, value, index, ...other }) {
  return (
    <Box hidden={value !== index} role="tabpanel" {...other}>
      {value === index && children}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default TabPanel;
